import * as React from "react"

import {cn} from "@/lib/utils/cn"

const Card = React.forwardRef(({className, ...props}, ref) => (
    <div
        ref={ref}
        className={cn("rounded-xl border bg-card text-card-foreground shadow bg-white dark:bg-gray-700", className)}
        {...props} />
))
Card.display_name = "Card"

const CardHeader = React.forwardRef(({className, ...props}, ref) => (
    <div
        ref={ref}
        className={cn("flex flex-col space-y-1.5 p-6 bg-white dark:bg-gray-700 rounded-xl", className)}
        {...props} />
))
CardHeader.display_name = "CardHeader"

const CardTitle = React.forwardRef(({className, ...props}, ref) => (
    <div
        ref={ref}
        className={cn("font-semibold leading-none tracking-tight bg-white dark:bg-gray-700", className)}
        {...props} />
))
CardTitle.display_name = "CardTitle"

const CardDescription = React.forwardRef(({className, ...props}, ref) => (
    <div
        ref={ref}
        className={cn("text-sm text-muted-foreground", className)}
        {...props} />
))
CardDescription.display_name = "CardDescription"

const CardContent = React.forwardRef(({className, ...props}, ref) => (
    <div ref={ref} className={cn("p-6 pt-0", className)} {...props} />
))
CardContent.display_name = "CardContent"

const CardFooter = React.forwardRef(({className, ...props}, ref) => (
    <div
        ref={ref}
        className={cn("flex items-center p-6 pt-0", className)}
        {...props} />
))
CardFooter.display_name = "CardFooter"

export {Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent}
